import appStore from 'store';
import api from './api';
import { STATUS_TYPE } from './constants';
const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    datas: [],
    totalCount: 0,
    airdropPagination: {
      page: 1,
      size: 25
    },
    airdropTotalCount: 0,
    airdrops: [],
    detail: null,
    activeTab: '0',
    unTransInfo:[]
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item,
        __status: STATUS_TYPE[item.taskStatus]
      }));
    }
  },
  mutations: {
    setList(state, payload) {
      state.datas = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setAirDropList(state, payload) {
      state.airdrops = payload.list.concat();
      state.airdropTotalCount = payload.totalCount;
    },
    setAirDropPagination(state, payload) {
      state.airdropPagination = payload;
    },
    setDetail(state, payload) {
      state.detail = payload;
    },
    changeTab(state, payload) {
      state.activeTab = payload;
    },
    setUnTransInfo(state,payload) {
      state.unTransInfo = payload;
    }
  },
  actions: {
    reqList({ commit }, query) {
      api.reqList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    reqAirDrops({ commit }, query) {
      return api.reqAirDrops(query).then(({ data }) => {
        commit('setAirDropList', data);
        commit('setAirDropPagination', { size: query.size, page: query.page });
      });
    },
    importAirDrop(context, data) {
      return api.importAirDrop(data);
    },
    checkAirDrop(context, data) {
      return api.checkAirDrop(data);
    },
    reqUnTransfer({commit},data) {
      api.reqUnTransfer(data).then(response =>{
          commit('setUnTransInfo',response.data);
      })
    }
  }
};

appStore.registerModule('airdrop', store);
